module.exports = __webpack_public_path__ + "static/img/fwlc.d8b2995.png";


//////////////////
// WEBPACK FOOTER
// ./static/deposit/fwlc.png
// module id = 9IzC
// module chunks = 1